module.exports = __webpack_public_path__ + "img/delete.a95f62d1.svg";